import { useRef, useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom";
import {
  Box,
  List,
  ListItemText,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import ViewListIcon from '@mui/icons-material/ViewList';
import FolderIcon from '@mui/icons-material/Folder';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import ToggleButton from '@mui/material/ToggleButton';
import Button from '@mui/material/Button';
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ListItemButton from '@mui/material/ListItemButton';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { usePbiGetTenantDetailsMutation, usePbiGetUserDetailsMutation, usePbiReportListMutation, usePbiReportDetailsMutation, usePbiGetSubscriptionsMutation, usePbiClearCacheDataMutation, usePbiManualRefreshStatusMutation, usePbiAdminUserAccessMutation } from '../features/auth/authApiSlice'
import { setTenantWorkspace, setTenantWorkspacelist, setPBIReportList, setSelectedReportDetails, setSelectedReportId, setUserPreference, setReportSelectedIndex, selectReportSelectedIndex, selectSelectedReportId, setSelectedReport, setReportLastUpadte } from '../features/auth/authSlice'
import { setUserData, setReportId, setUserSubscription, selectUserData, setSelectedFrequency, setSelectedOffset, setSelectedTimeOffset, setSubscriptionReportID, setIsStandardDB, selectIsStandardDB, selectReportId, setIsAdminAnalytics, selectIsAdminAnalytics, setReportSearchTxt, selectReportSearchTxt, selectPBIFolderList } from '../features/data/dataSlice'
import { selectCurrentUser, selectCurrentToken, selectPBIWorkspace, selectPBIReportList, selectSelectedReportDetails, selectPBIWorkspaceList, selectUserPreference } from "../features/auth/authSlice"
import { timezones } from '../features/users/timezonelist';
import { tokens } from "../assets/theme";
import Spinner from './Spinner';
import FolderDashboard from '../features/folderDashboard/folderdashboard';
import {updateObjectInSessionStorage} from '../utils/utils';


const ReportListSideBar = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [showSideBar, setShowSideBar] = useState(true);
  const [showListView, setShowListView] = useState(true);
  const [searchTxt, setSearchTxt] = useState("");
  const [folder, setFolder] = useState(false);
  const [errMsg, setErrMsg] = useState('')
  const [spinnerLoad, setSpinnerLoad] = useState(false)
  const isAdminSelector = useSelector(selectIsAdminAnalytics);
  const isStandardDb = useSelector(selectIsStandardDB);
  const user = useSelector(selectCurrentUser)
  const pbiworkspace = useSelector(selectPBIWorkspace)
  const preferencedtimezone = useSelector(selectUserData);
  const reportList = useSelector(selectPBIReportList);
  const reportSelectedIdx = useSelector(selectReportSelectedIndex)
  const reportSelectedID = useSelector(selectSelectedReportId)
  const searchText = useSelector(selectReportSearchTxt)
  const isUserCanCreate = preferencedtimezone && preferencedtimezone.canCreate ? true : false;
  const [pbiGetTenantDetails, { isPBITenantLoading }] = usePbiGetTenantDetailsMutation()
  const [pbiGetUserDetails, { isPBIGetUserLoading }] = usePbiGetUserDetailsMutation()
  const [pbiReportList, { isPBIReportLoading }] = usePbiReportListMutation()
  const [pbiReportDetails, { isPBIReportDetailsLoading }] = usePbiReportDetailsMutation()
  const [ pbiAdminUserAccess, { ispbidminUserAccessLoading } ] = usePbiAdminUserAccessMutation()
  const [pbiSubscriptionList, { ispbiSubscriptionListLoading }] = usePbiGetSubscriptionsMutation()
  const [pbiClearCacheData, { ispbiClearCacheDataLoading }] = usePbiClearCacheDataMutation()
  const [pbiManualRefreshStatus, { isPbiManualRefreshStatusLoading }] = usePbiManualRefreshStatusMutation();

  const [view, setView] = useState('list');
  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isAdmin, setIsAdmin] = useState(0);

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeIds) => {
    setSelected(nodeIds);
  };

  const handleChange = (event, nextView) => {
    setView(nextView);
  };

  const handleNewClick = () => {
    const standardReports = reportList.filter((report) => {
      if (report.name.toLowerCase().includes('_st_db_ecto_bi')) {
        return report
      }
    });
    if (standardReports.length) {
      handleReportClick(standardReports[0].reportId, pbiworkspace, 5000, standardReports[0])
      //    handleIframeOnload();
    }
  }

  // For Login Bypass local development - Starts
  // const handleGetAdminStatusLocal = () => {
  //   dispatch(setSelectedReportDetails(null))
  //   dispatch(setPBIReportList([]));
  //   if (user.toLocaleLowerCase().includes("analyst")) {
  //     setIsAdmin(0);
  //     dispatch(setIsAdminAnalytics(true))
  //     handleGetUserDetails(0)
  //   } else {
  //     setIsAdmin(1);
  //     dispatch(setIsAdminAnalytics(false))
  //     handleGetUserDetails(1)

  //   }
  // }
  //For Login Bypass local development - Ends

   const handleGetAdminStatus = async() => {
    dispatch(setSelectedReportDetails(null))
    dispatch(setPBIReportList([]));
    const logggedInDetails = {"username": user, "action":"CAN_EDIT_BI_REPORT_PERMISSION"}
    const getGetAdminStatus = await pbiAdminUserAccess(logggedInDetails).unwrap()
    if(getGetAdminStatus && getGetAdminStatus.canEditReport.toLowerCase() == "true") {
      setIsAdmin(0);
      dispatch(setIsAdminAnalytics(true))
      handleGetUserDetails(0)
    } else {
      setIsAdmin(1);
      dispatch(setIsAdminAnalytics(false))
      handleGetUserDetails(1)
    }
  }

  const handleGetUserDetails = async (value) => {
    const logggedInDetails = { "loginId": user }
    const getUserDetails = await pbiGetUserDetails(logggedInDetails).unwrap()
    if (getUserDetails) {
      const userpreferencedata = { locale: getUserDetails.language && getUserDetails.language.languageId ? getUserDetails.language.languageId : 'en', defaultCulture: getUserDetails.language && getUserDetails.language.defaultCulture ? getUserDetails.language.defaultCulture : 'en-US', themedark: getUserDetails.theme && getUserDetails.theme.toLowerCase() == 'dark' ? true : false, timezone: getUserDetails.timeZone ? getUserDetails.timeZone : 'GST' }
      dispatch(setUserData(getUserDetails))
      dispatch(setUserPreference(userpreferencedata))
      handleGetTenantDetails(value);
    }
  }

  const handleGetTenantDetails = async (value) => {
    const logggedInDetails = { "loginId": user }
    const getTenantDetails = await pbiGetTenantDetails(logggedInDetails).unwrap()
    if (getTenantDetails && getTenantDetails.length) {
      dispatch(setTenantWorkspace(getTenantDetails[0].workspaceId))
      dispatch(setTenantWorkspacelist(getTenantDetails))
      setTimeout(() => {
        handlePBIReportList(getTenantDetails[0].workspaceId, value);
      }, 1000);
      handleGetAllSubscripion();
    }
  }

  const handleGetAllSubscripion = async () => {
    try {
      const logindetails = { "loginId": user }
      const getSubscriptionList = await pbiSubscriptionList(logindetails).unwrap()
      if (getSubscriptionList && getSubscriptionList.subscriptions) {
        dispatch(setUserSubscription(getSubscriptionList.subscriptions))
      } else {
        dispatch(setUserSubscription([]))
      }
    } catch (err) {
      if (!err?.originalStatus) {
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
    }
  }

  const handleRefreshedHistory = async (report, workspacedetails) => {
    const requestbody = { "datasetId": [report.datasetId], "groupId": workspacedetails }
    let refreshStatus = await pbiManualRefreshStatus(requestbody).unwrap();
    if (refreshStatus && refreshStatus.value.length > 0) {
      dispatch(setReportLastUpadte(refreshStatus.value));

      if (refreshStatus.value[0].status == 'Completed') {
        // props.setRefreshClicked(false);
        updateObjectInSessionStorage('reportRefreshStatus', report.datasetId, false);
      }
    }
  }
  const handleReportClick = async (reportid, workspacedetails, index, report) => {
    if (reportSelectedID != reportid) {
      localStorage.setItem('reportrendered', JSON.stringify("false"));
      localStorage.setItem('filterdata', JSON.stringify([]));
    }
    props.setReportObj(report)
    dispatch(setSelectedReportId(reportid))
    dispatch(setTenantWorkspace(workspacedetails))
    dispatch(setReportId(reportid))
    handleRefreshedHistory(report, workspacedetails);
    let reportDetails = { "workspaceId": workspacedetails, "reportId": reportid, "userId": user }
    const getReportDetails = await pbiReportDetails(reportDetails).unwrap()
    dispatch(setReportSelectedIndex(index))
    setTimeout(() => {
      dispatch(setSelectedReportDetails(getReportDetails))
      navigate('/home')
    }, 1000);
  }

  const handleClearCache = async () => {
    let clearData = await pbiClearCacheData(pbiworkspace).unwrap();
  }

  const handleReloadReportList = () => {
    setSpinnerLoad(true);
    handleClearCache();
    if (isAdminSelector) {
      handlePBIReportList(pbiworkspace, 0);
    } else {
      handlePBIReportList(pbiworkspace, 1);
    }
  }

  const handlePBIReportList = async (workspacedetails, value) => {

    try {
      const workspaceid = { "workspaceId": workspacedetails, "IsUserReportPermission": value == 0 ? false : true }
      setSpinnerLoad(true)
      // let workspaceid = { "workspaceId": "6eacca4f-9e75-400d-8047-74d37d0a9028" }
      const getReportList = await pbiReportList(workspaceid).unwrap()
      if (getReportList && getReportList.reports) {
        let report_list = getReportList.reports;
        let sortedReportList = report_list.slice().sort((a, b) => a.name.localeCompare(b.name))
        setTimeout(() => {
          dispatch(setPBIReportList(sortedReportList))
          if (sortedReportList.length) {
            if (sortedReportList.length > 1 && sortedReportList[0].name.toLocaleLowerCase().includes('_st_db_ecto_bi')) {
              const activereportid = sortedReportList[1].reportId ? sortedReportList[1].reportId : null
              if (activereportid) {
                handleReportClick(activereportid, workspacedetails, 0, sortedReportList[1])
              }
            } else {
              if (!sortedReportList[0].name.toLocaleLowerCase().includes('_st_db_ecto_bi')) {
                const activereportid = sortedReportList[0].reportId ? sortedReportList[0].reportId : null
                if (activereportid) {
                  handleReportClick(activereportid, workspacedetails, 0, sortedReportList[0])
                }
              }
            }
          }

          setSpinnerLoad(false)
          if (sortedReportList.length) {
            const stdbectobi = sortedReportList.filter(report => report.name.toLocaleLowerCase().includes('_st_db_ecto_bi'));
            if (stdbectobi.length) {
              dispatch(setIsStandardDB(true))
            } else {
              dispatch(setIsStandardDB(false))
            }
          }
        }, 1000);
      }

    } catch (err) {
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
    }
  }

  const convertRefreshDateTimezone = datetime => {
    let timezoneabbr = preferencedtimezone && preferencedtimezone.timeZone ? preferencedtimezone.timeZone : "UTC";
    let timezoneobj = timezones.find(item => item.abbr == timezoneabbr);
    let epochval = new Date(datetime).valueOf() + ((timezoneobj.offset ? timezoneobj.offset : 0) * 60 * 60000);
    let lastRefreshDate = new Date(epochval).toISOString().replace('T', ', ').replace('Z', '');
    return lastRefreshDate;
  }

  useEffect(() => {
    try {
      if (!reportSelectedID) {
         handleGetAdminStatus();
        //For Login Bypass local development - Starts
        // handleGetAdminStatusLocal();
        //For Login Bypass local development - Ends
      }
    } catch (err) {
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
    }
  }, [])

  const handleClearSearch = () => {
    if (searchTxt != "") {
      setSearchTxt("")
    }
  }
  return (
    <>
      {!showSideBar && (
        <Box flex="1 1 2%"
          backgroundColor={colors.primary[400]}
          p="13px 2px 3px 2px"
          borderRadius="4px"
          className="collapsedReportList">
          <IconButton onClick={() => { setShowSideBar(prev => !prev); setSearchTxt("") }} type="button" sx={{ p: 0.5 }}>
            <ArrowForwardIosIcon />
          </IconButton>
          <p className="verticaltext-listreport">Reports</p>
        </Box>
      )}
      {showSideBar && (
        <Box
          flex="1 1 20%"
          backgroundColor={colors.primary[400]}
          p="15px"
          borderRadius="4px"
          className="boxreportlist"
        >
          <div className="listreport-action">
            {isAdminSelector && isStandardDb && (<Button variant="contained" sx={{ m: 0.5, ml: 1 }} startIcon={<AddCircleOutlineIcon />} onClick={handleNewClick}>New</Button>)}
            <ToggleButtonGroup
              orientation="horizontal"
              className="reporttogglebutton"
              value={view}
              exclusive
              onChange={handleChange}
            >
              <ToggleButton onClick={() => {
                setShowListView(true)
                setFolder(false)
              }} value="list" aria-label="list">
                <ViewListIcon />
              </ToggleButton>
              <ToggleButton onClick={() => {
                setFolder(true)
                setShowListView(false)
              }} value="module" aria-label="module">
                <FolderIcon />
              </ToggleButton>
              <ToggleButton onClick={handleReloadReportList} value="refresh" aria-label="refresh">
                <RefreshIcon />
              </ToggleButton>
              <ToggleButton onClick={() => setShowSideBar(prev => !prev)}>
                <ArrowBackIosIcon className="listreportcollapseicn" />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div>
            {/* SEARCH BAR */}
            <Box
              display="flex"
              backgroundColor={colors.primary[400]}
              borderRadius="3px"
              className="searchreportbox"
            >

              <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search"
                value={searchTxt}
                onChange={e => { setSearchTxt(e.target.value) }} />
              {searchTxt !== '' ?
                (<IconButton type="button" sx={{ p: 1 }} onClick={handleClearSearch}>
                  <CloseIcon />
                </IconButton>) :
                (<IconButton type="button" sx={{ p: 1 }} >
                  <SearchIcon />
                </IconButton>)
              }

            </Box>
            {/* <Typography variant="h5">List</Typography> */}
            {showListView && <List className="ul-reportlist">
              {reportList && reportList.length === 0 && spinnerLoad && (<span>Loading...</span>)}
              {reportList && reportList.length === 0 && !spinnerLoad && (<span>No Data Available...</span>)}
              {showListView && reportList && (
                <>{reportList.filter((report) => {
                  if (searchTxt == "") {
                    if (!report.name.toLowerCase().includes('_st_db_ecto_bi') && !report.name.toLowerCase().includes('paginated_') && !report.name.toLowerCase().includes('paginated-')) {
                      return report
                    }
                  } else {
                    if (report.name.toLowerCase().includes(searchTxt.toLocaleLowerCase()) && !report.name.toLowerCase().includes('_st_db_ecto_bi') && !report.name.toLowerCase().includes('paginated_') && !report.name.toLowerCase().includes('paginated-')) {
                      return report
                    }
                  }
                }).map((report, index) => (
                  <ListItemButton
                    className="div-listreport"
                    selected={reportSelectedIdx === report.reportId && searchTxt == ""}
                    onClick={() => handleReportClick(report.reportId, pbiworkspace, report.reportId, report)}
                  >
                    <ListItemText
                      className="reportlistitem"
                      primary={report.name}
                      title={report.name}
                      secondary={<>
                        <Typography className="p-lastupdateon">
                          Last refreshed on: {report.reportsRefreshHistory && report.reportsRefreshHistory.endTime ? convertRefreshDateTimezone(report.reportsRefreshHistory.endTime) : "NA"}
                        </Typography>
                      </>
                      }
                    />
                  </ListItemButton>
                ))}</>
              )}
            </List>
            }
            <div className="showfolderReportList" >
              <FolderDashboard selectedReport={reportSelectedID} searchTxt={searchTxt} folder={folder} setSearchTxt={setSearchTxt} />
            </div>
          </div>
        </Box>
      )}

      {spinnerLoad && (<Spinner />)}
    </>
  );
};

export default ReportListSideBar;
